import React, { useState } from 'react';
import Link from 'next/link';
import { LoadingIndicator } from '@havenengineering/module-shared-library/dist/components/LoadingIndicator';
import { SectionHeader } from '@havenengineering/module-shared-owners-ui/dist/components/SectionHeader';
import { useAuthContext } from '@havenengineering/module-shared-owners-ui/dist/contexts/auth';
import useSWRImmutable from 'swr/immutable';

import { swrLocalFetcher } from '../../../helpers/fetch';
import categoryTabs from '../../../resources/contentfulArticleTabs.json';
import styles from './CategoryView.module.scss';
import SingleCategory from './SingleCategory/SingleCategory';

interface Props {
  showHowToGuides?: boolean;
  showLinkToNews?: boolean;
}

const CategoryView = ({ showHowToGuides, showLinkToNews }: Props) => {
  const [activeCategory, setActiveCategory] = useState(categoryTabs[0]);
  const { activeAccount } = useAuthContext();
  const { data: categories } = useSWRImmutable<Categories>(
    activeAccount?.parkCode &&
      `/owners-content/categories?parkCode=${activeAccount.parkCode}`,
    swrLocalFetcher
  );

  const isCategoryTabActive = (id: string) => activeCategory.id === id;

  const selectCategoryTab = (selectedId: string) => () => {
    const newActiveCategory =
      categoryTabs.find(({ id }) => id === selectedId) || categoryTabs[0];
    setActiveCategory(newActiveCategory);
  };

  return !categories ? (
    <div className={styles.loadingContainer}>
      <LoadingIndicator loading />
    </div>
  ) : (
    <>
      <SectionHeader
        title="News"
        extraContent={
          (showLinkToNews && (
            <Link href="/news-and-information">
              <span className={styles.sectionHeaderLink}>
                See all News & information
              </span>
            </Link>
          )) ||
          undefined
        }
      />
      <div className={styles.tabContainer}>
        {categoryTabs.map((categoryTab, index) => (
          <div
            key={categoryTab.id}
            className={styles.tab}
            onClick={selectCategoryTab(categoryTab.id)}
          >
            <div>
              {index > 0 && <span className={styles.tabDivider}>|</span>}
              <span
                className={
                  isCategoryTabActive(categoryTab.id)
                    ? styles.activeTabText
                    : ''
                }
              >
                {categoryTab.title}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.categoriesContainer}>
        <SingleCategory articlesInCategory={categories[activeCategory.id]} />
      </div>

      {showHowToGuides && (
        <>
          <SectionHeader title="How to guides" />
          <SingleCategory
            articlesInCategory={categories['guides'].sort(
              (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
            )}
          />
        </>
      )}
    </>
  );
};

export default CategoryView;
